import { combineReducers } from 'redux';

const newPropertyFromScratchReducer =
  function (state = {}, action) {
    switch (action.type) {
    case 'change_address': {
      return { ...state, address: action.address };
    }
    case 'change_city': {
      return { ...state, city: action.city };
    }
    case 'change_country': {
      return { ...state, country: action.country };
    }
    case 'change_state': {
      return { ...state, state: action.state };
    }
    case 'change_zip': {
      return { ...state, zip: action.zip };
    }
    case 'change_county': {
      return { ...state, county: action.county };
    }
    case 'change_sale_or_lease': {
      return { ...state, sale_or_lease: action.sale_or_lease };
    }
    case 'change_name': {
      return { ...state, name: action.name };
    }
    case 'change_location_description': {
      return { ...state, location_description: action.location_description };
    }
    case 'change_property_type_id': {
      return { ...state, property_type_id: action.property_type_id };
    }
    case 'change_building_size': {
      return { ...state, building_size: action.building_size };
    }
    case 'change_building_class': {
      return { ...state, building_class: action.building_class };
    }
    case 'change_aiIngestMetadata': {
      return { ...state, aiIngestMetadata: action.aiIngestMetadata };
    }
    case 'change_aiFeedback': {
      return { ...state, aiFeedback: action.aiFeedback };
    }
    case 'change_showAiFeedbackForm': {
      return { ...state, showAiFeedbackForm: action.showAiFeedbackForm };
    }
    case 'set_aiPopulatedFields': {
      return { ...state, aiPopulatedFields: action.aiPopulatedFields };
    }
    case 'set_currentAiFields': {
      return { ...state, currentAiFields: action.currentAiFields };
    }
    case 'set_inferredFields': {
      return { ...state, inferredFields: action.inferredFields };
    }
    case 'set_aiDocUploadSuccess' : {
      return { ...state, aiDocUploadSuccess: action.aiDocUploadSuccess };
    }
    default: {
      return { zip: '', state: '', city: '', address: '', ...state };
    }
    }
  };

export default combineReducers({
  brokerSelectOptions: (state = []) => state, // readonly
  propertyTypes: (state = {}) => state, // readonly
  newPropertyFromScratchLocation: newPropertyFromScratchReducer
});
